import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { ReactComponent as Close } from "../../../assets/images/teamclose.svg";
import { ReactComponent as ChatTag } from "../../../assets/images/TicketImages/tag.svg";
import { ReactComponent as AddTag } from "../../../assets/images/ChatImages/addsign.svg";
import { ReactComponent as SelectedTag } from "../../../assets/images/TicketImages/label-tag.svg";
import SearchInput from "../../common/SearchInputField";
import { CircularProgress, Box } from "@mui/material";
import { addTagToTagList } from "../../../store/features/addTagToTagList";
import NoSearch from "../../common/NoSearch";
import { fetchTags } from "../../../store/features/tagsApi";

function TagPopup({ onClose, onApply, selectedTags = [] }) {
  const dispatch = useDispatch();
  const businessId = useSelector((state) => state.loginToken?.response?.user?.business_id);
  const { list: availableTags = [], loading } = useSelector((state) => state.tags);

  const [searchQuery, setSearchQuery] = useState("");
  const [newTag, setNewTag] = useState("");
  const [tags, setTags] = useState([]);
  const [filteredTags, setFilteredTags] = useState([]);
  const [selectedTagIds, setSelectedTagIds] = useState(selectedTags);
  const [isLoading, setIsLoading] = useState(true);

  const initialSelectedTagIds = React.useMemo(
    () =>
      Array.isArray(selectedTags)
        ? selectedTags.map((tag) => (typeof tag === "object" ? tag._id : tag))
        : [],
    [selectedTags]
  );

  useEffect(() => {
    if (businessId) {
      dispatch(fetchTags({ businessId, type: "conversation" }));
    }
  }, [dispatch, businessId]);

  useEffect(() => {
    const filteredAvailableTags = availableTags.filter(
      (tag) => !initialSelectedTagIds.includes(tag._id)
    );
    setTags(filteredAvailableTags);
    setFilteredTags(filteredAvailableTags);
    setIsLoading(loading);
    if (!loading) setIsLoading(false);
  }, [availableTags, loading, initialSelectedTagIds]);

  const handleSearchInputChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredResults = tags.filter((tag) =>
      tag.name.toLowerCase().includes(query)
    );
    setFilteredTags(filteredResults);
  };

  const handleNewTagChange = (e) => {
    setNewTag(e.target.value);
  };

  const handleAddTag = async () => {
    if (newTag.trim() !== "") {
      // if tag legth is more than 20 characters, show error
      if (newTag.length > 20) {
        toast.error("Tag name cannot exceed 20 characters");
        return;
      }
      try {
        const resultAction = await dispatch(
          addTagToTagList({ name: newTag.trim() })
        );
        if (addTagToTagList.fulfilled.match(resultAction)) {
          toast.success("Tag added!");

          setNewTag("");
        } else {
          toast.error(resultAction.payload?.message || "Failed to add tag");
        }
      } catch (error) {
        toast.error("Failed to add tag");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleAddTag();
    }
  };

  const handleTagClick = (tagId) => {
    setSelectedTagIds((prevSelected) => {
      if (prevSelected.includes(tagId)) {
        return prevSelected.filter((id) => id !== tagId);
      } else {
        return [...prevSelected, tagId];
      }
    });
  };

  const handleApply = async () => {
    const allSelectedIds = [...initialSelectedTagIds, ...selectedTagIds];
    const selectedTagsData = availableTags.filter((tag) =>
      allSelectedIds.includes(tag._id)
    );

    onClose();
    // Awaited, and with no refetch of its own: onApply writes the tags and then
    // reloads the ticket. Refetching here raced that write and answered with the
    // pre-update tag list, which wiped the tag that was just applied.
    if (onApply) {
      await onApply(selectedTagsData);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <>
      <div className="overlay" />
      <div className="Assign-PopUp-Container">
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">Add Tag</p>
          <p className="PopUp-Text02" onClick={onClose}>
            <Close />
          </p>
        </div>

        <div className="SearchChat-Popup">
          <SearchInput
            title=""
            placeholder="Search tags"
            value={searchQuery}
            onChange={handleSearchInputChange}
          />
        </div>

        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <div
            className="AgentsList"
            style={{
              maxHeight: "200px", overflowY: "auto", padding: '0px'
            }}>
            {
              filteredTags.length === 0 ? (
                <NoSearch
                  title="No tags found"
                  description="Try searching with different keywords or create a new tag."
                />
              ) : (
                filteredTags.map((tag) => (
                  <div style={{ padding: '8px 16px' }}
                    className={`ChatPopup-Darleen-Container ${selectedTagIds.includes(tag._id) ? "" : ""
                      }`}
                    key={tag._id}
                    onClick={() => {
                      if (selectedTagIds.length >= 5 && !selectedTagIds.includes(tag._id)) {
                        toast.error("You can only add up to 5 tags.");
                        return;
                      }
                      handleTagClick(tag._id);
                    }}


                  >

                    <Box
                      sx={{
                        display: "flex", // Add this back
                        alignItems: "center",
                        justifyContent: "center",
                        width: "24px",
                        height: "24px",
                        "& svg path": {
                          stroke: selectedTagIds.includes(tag._id) ? "#148DFD" : "#556575",
                        },
                      }}
                    >
                      <ChatTag />
                    </Box>

                    <div>
                      <p

                        style={{
                          color: selectedTagIds.includes(tag._id) ? "#061522" : "#556575",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          marginTop: '1px'
                        }}

                      >
                        {tag.name}
                      </p>
                      {tag.isNew && (
                        <p className="No-activetext" style={{ color: "#28a745" }}>
                          New tag
                        </p>
                      )}
                    </div>
                  </div>
                ))
              )
            }
          </div>
        )}

        <hr
          style={{
            backgroundColor: "#F1F3F5",
            height: "1px",
            border: "none",
            margin: "16px 0",
          }}
        />

        {/* <div className="ChatPopup-Darleen-Container" style={{
          width: '100%',
          padding: '8px',
          border: '1px solid #E0E0E0',
          borderRadius: '8px',
          fontSize: '14px',
          color: '#556575',
          fontWeight: 400,
          lineHeight: 'normal',
          background: '#FFFFFF',
          marginBottom: '16px',
          boxShadow: '0px 1px 2px 0px rgba(6, 21, 34, 0.05)'
        }}>
          <p>
            <ChatTag />
          </p>
          <div style={{ flex: 1 }}>
            <input
              type="text"
              placeholder="New tag"
              value={newTag}
              onChange={handleNewTagChange}
              onKeyPress={handleKeyPress}
              style={{
                width: '100%',
                border: 'none',
                outline: 'none',
                fontSize: '14px',
              }}
            />
          </div>
          <p
            onClick={handleAddTag}
            style={{ cursor: 'pointer', opacity: newTag.trim() ? 1 : 0.5 }}
          >
            <AddTag />
          </p>
        </div> */}

        <div style={{ display: "flex", width: "100%", gap: "8px" }}>
          <button
            className="cancel-btn"
            onClick={handleCancel}
            style={{
              background: "transparent",


              padding: "8px 16px",
              borderRadius: "8px",
              cursor: "pointer",
              width: "100%",
            }}
          >
            Cancel
          </button>
          <button
            className="AddTansfer"
            onClick={handleApply}
            style={{
              width: "100%",
            }}
          >
            Apply
          </button>
        </div>
      </div >
    </>
  );
}

export default TagPopup;
